<template>
  <div>
    <v-dialog v-model="dialog" flat persistent width="900px" color="white">
      <v-card flat color="grey lighten-4" width="700px" class="mx-auto pa-8 mt-7">
        <a href="https://www.firstcryintellitots.com/"><v-btn icon color="error" absolute top
            right><v-icon>mdi-close-circle</v-icon></v-btn></a>
        <v-card-title class="primary--text display-3 font-weight-bold justify-center">Thank You !</v-card-title>
        <v-icon class="d-flex justify-center my-2" size="150" color="pink">mdi-emoticon</v-icon>
        <v-card-subtitle class="d-flex justify-center my-2 title">Your Admission form is submitted successfully.</v-card-subtitle>
      </v-card>
    </v-dialog>
    <section class="">
      <div class="level-item d-flex justify-center mt-4">
        <img width="200px" src="https://cdn.fcglcdn.com/brainbees/intelli/intellitots/images/Intellitots-logo.png" />
      </div>
      <br />

      <div class="level-item">
        <p class="title is-2">Admission Form</p>
      </div>
    </section>
    <section class="container section page-header section is-main-section">
      <div v-if="parentdata">
        <form class="container" @submit.prevent="saveRegistration()">
          <div>
            <div class="wrapper">
              <div class="container d-flex flex-row">
                <v-btn-toggle
                  v-model="selectedButton"
                  group
                  borderless
                  color="green darken-4"
                  mandatory
                  dense
                >
                  <v-btn
                    class="text-uppercase"
                    @click="gotToMainForm()"
                  >
                    Form At The Time Of Admission
                  </v-btn>
                  <template v-if="isFranchiseeUser_1 || isSuperAdmin">
                    <v-btn
                      v-for="(keyName, index) in Object.keys(editRequestList)"
                      :key="`request_btn_${index}`"
                      class="text-uppercase"
                      @click="showEditRequestForm(keyName, index+1)"
                    >
                      Request {{ index+1 }}
                    </v-btn>
                  </template>
                </v-btn-toggle>
              </div>
              <div v-show="isOldFormViewRequested" class="main-form">
                <div class="container">
                  <StudentElement formType='studEdit' v-model="studentData" isWritable="true" isRequired="true" />
                </div>
                <div class="container">
                  <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="father"
                    v-model="studentData" />
                </div>
                <div class="container">
                  <RegParentElement :formType="this.typeForm" :isWritable="this.message" parentType="mother"
                    v-model="studentData"  @setIsCompop="franchiseeCheck"/>
                </div>
                <div class="container" v-if="showGaurdian">
                  <RegParentElement :formType="this.typeForm" :isWritable="showGaurdian" parentType="guardian"
                    v-model="studentData" @closeIcon="closeDialog"/>
                </div>
                <div class="container">
                  <AddressElement v-model="studentData" isWritable="true" formType="applicationForm" />
                </div>
                <div class="container">
                  <OtherElement :formType="this.typeForm" :isWritable="this.message" v-model="studentData" />
                </div>
                <div class="container">
                  <SiblingElement :formType="this.typeForm" :isWritable="this.message" v-model="registrationData" />
                </div>
                <div class="container">
                  <HealthElement :formType="this.typeForm" :isWritable="this.message" v-model="registrationData" />
                </div>
                <div class="container" v-if="this.isLoaded === 'true'">
                  <RegDocumentElement :formType="this.typeForm" :isWritable="this.message" v-model="registrationData" />
                </div>
                <div class="container">
                  <IAgreeCheckbox v-model="registrationData" />
                </div>

                <footer class="column has-text-right">
                  <input class="button is-success" type="submit" value="Confirm" />
                </footer>
              </div>
              <div class="edit-personal-requested-form" v-if="isPersonalDataChanges && (isFranchiseeUser_1 || isSuperAdmin)">
                <v-card>
                  <v-card-text>
                    <v-data-table
                      :headers="tableHeader"
                      :items="personalDetailsData"
                      hide-default-footer
                      dense
                    >
                      <template v-slot:item.isChange = '{item}'>
                        {{ capitalizeFLetter(item.isChange) }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
                <div v-for="(item, index) in personalDetailsData" :key="`personal_${index}`">
                  <ApproveRegParentElement
                    :formType="editRequestFormType"
                    isWritable="false"
                    v-model="personalDetailsData[index]"
                    :parentType="item.isChange"
                    :compareStudentData ="studentData"
                    :enquiryID = 'enquiryID'
                    @onStart="onstart"
                  />
                </div>
              </div>
              <div class="edit-health-requested-form" v-if="isHealthDataChanges && (isFranchiseeUser_1 || isSuperAdmin)">
                <v-card>
                  <v-card-text>
                    <v-data-table
                      :headers="tableHeader"
                      :items="healthDetailsData"
                      hide-default-footer
                      dense
                    >
                      <template v-slot:item.isChange = '{item}'>
                        {{ capitalizeFLetter(item.isChange) }}
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
                <ApproveHealthElement
                  :formType="editRequestFormType"
                  v-model="groupHealthDetailsData"
                  :isWritable="false"
                  :parentType="'health'"
                  :compareHealthData ="registrationData"
                  :enquiryID = 'enquiryID'
                  @onStart="onstart"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import constants from '@/utils/constants'
import _ from 'lodash'
import moment from 'moment'
import store from '@/stores'
// import FranchiseeElement from '@/components/Forms/Elements/FranchiseeElement'
import StudentElement from '@/components/Forms/Elements/StudentElement'
import AddressElement from '@/components/Forms/Elements/AddressElement'
import HealthElement from '@/components/Forms/Elements/HealthElement'
import RegDocumentElement from '@/components/Forms/Elements/RegDocs'
import SiblingElement from '@/components/Forms/Elements/SiblingElement'
import IAgreeCheckbox from '@/components/Forms/Elements/IAgreeCheckbox'
// import ParticularList from '../Fees/payment/particularList'
import OtherElement from '@/components/Forms/Elements/OtherElement'
import RegParentElement from '@/components/Forms/Elements/RegParentElement'
import ApproveRegParentElement from '@/components/Forms/Elements/ApproveParentElementChanges'
import ApproveHealthElement from '@/components/Forms/Elements/ApproveHealthElement'

export default {
  name: 'ApplicationFormOfflineStudent',
  props: ['admissionID'],
  components: {
    StudentElement,
    RegParentElement,
    ApproveRegParentElement,
    AddressElement,
    // ParticularList,
    HealthElement,
    RegDocumentElement,
    SiblingElement,
    IAgreeCheckbox,
    OtherElement,
    ApproveHealthElement
  },
  data: function () {
    return {
      isSuperAdmin: false,
      selectedButton: 0,
      selectedRequestButtonIndex: 0,
      checkboxGroup: ['SMS'],
      parentdata: {},
      studentData: {},
      registrationData: {},
      enableModal: false,
      enableChangeRequestModal: false,
      showSection: '',
      franchiseeName: '',
      academicYr: '',
      className: '',
      query: '',
      enquiryCode: '',
      typeForm: 'edit_registration',
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      payModal: false,
      formType: '',
      message: 'true',
      isLoaded: 'false',
      dialog: false,
      showGaurdian: false,
      enquiryID: '',
      requestButtonList: [],
      editRequestList: [],
      editRequestKeyName: [],
      isOldFormViewRequested: true,
      isPersonalDataChanges: false,
      isHealthDataChanges: false,
      personalDetailsData: [],
      healthDetailsData: [],
      groupHealthDetailsData: {},
      editRequestFormType: '',
      isFranchiseeUser_1: false,
      selectRequestButton: null,
      tableHeader: [
        { text: 'Requested By', value: 'isChange', align: 'center' },
        { text: 'Requested On', value: 'createdAt', align: 'center' },
        { text: 'Number Of Field', value: 'count', align: 'center' },
        { text: 'Changes Made At', value: 'updatedAt', align: 'center' }
      ]
    }
  },
  async created () {
    let userStore = store.user
    if (userStore.ACL.superAdmin) {
      this.isSuperAdmin = true
    } else {
      userStore.roles.forEach(item => {
        if (constants.ADMISSION_OFFLINE_ROLE_ACCESS.includes(item.role)) {
          this.isFranchiseeUser_1 = true
        }
      })
    }
    await this.onstart()
    await this.writable()
  },

  methods: {
    writable: async function () {
      if (this.isLoaded === 'true') {
        this.message = 'false'
        this.typeForm = 'edit_registration'
      }
    },
    capitalizeFLetter (string) {
      return string[0].toUpperCase() + string.slice(1)
    },
    franchiseeCheck: function (isCompoFlag) {
      this.showGaurdian = isCompoFlag
    },
    closeDialog: function (isCompoFlag) {
      this.showGaurdian = isCompoFlag
    },
    gotToMainForm: function () {
      this.selectedRequestButtonIndex = 0
      this.isOldFormViewRequested = true
      this.isPersonalDataChanges = false
      this.isHealthDataChanges = false
    },
    onstart: async function () {
      try {
        const { data } = await http.get(`${constants.API_URL}/api/getReferenceStudentDetails/v1/${this.admissionID}`)
        let getRefDetails = data
        if (!_.isEmpty(getRefDetails)) {
          this.parentdata = data
          if (!_.isEmpty(this.parentdata.studentEnrollment.enquiry.enquiryRegistrations)) {
            let registrationData = this.parentdata.studentEnrollment.enquiry.enquiryRegistrations
            this.registrationData = registrationData[0]
            this.isRegistered = true
          }

          this.studentData = this.parentdata.studentEnrollment
          this.enquiryID = this.studentData.enquiryID
          if (this.studentData.guardianName) {
            this.showGaurdian = true
          }
          // get image list
          this.registrationData.prescribedMedication1 = this.registrationData.enquiryRegistrationPrescribedMedicationDocMaps
          if (this.registrationData.prescribedMedication1) {
            this.registrationData.prescribedMedication1.forEach((docID) => {
              // fetch filename from urlPath and add it to name key.
              let name = docID.urlPath.substring(docID.urlPath.lastIndexOf('/') + 1)

              // Truncate the name if it is too long
              docID.name = this.truncateFileName(name)
            })
          }
          this.studentData.fatherOccupation = !_.isEmpty(this.parentdata.studentEnrollment.fatherOccupation) ? this.parentdata.studentEnrollment.fatherOccupation : ''
          this.studentData.motherOccupation = !_.isEmpty(this.parentdata.studentEnrollment.motherOccupation) ? this.parentdata.studentEnrollment.motherOccupation : ''
          this.studentData.gender = _.startCase(_.toLower(this.parentdata.studentEnrollment.gender))
          this.studentData.emergencyContactDetails = !_.isEmpty(this.registrationData.emergencyContactDetails) ? this.registrationData.emergencyContactDetails : ''
          this.studentData.fatherDesignation = !_.isEmpty(this.registrationData.fatherDesignation) ? this.registrationData.fatherDesignation : ''
          this.studentData.fatherQualification = !_.isEmpty(this.registrationData.fatherQualification) ? this.registrationData.fatherQualification : ''
          this.studentData.fatherOrganisation = !_.isEmpty(this.registrationData.fatherOrganisation) ? this.registrationData.fatherOrganisation : ''
          this.studentData.fatherOfficePhoneNo = !_.isEmpty(this.registrationData.fatherOfficePhoneNo) ? this.registrationData.fatherOfficePhoneNo : ''
          this.studentData.fatherOfficeAddress =
            !_.isEmpty(this.registrationData.fatherOfficeAddress) && this.registrationData.fatherOfficeAddress !== 'undefined' ? this.registrationData.fatherOfficeAddress : ''
          this.studentData.motherDesignation =
            !_.isEmpty(this.registrationData.motherDesignation) && this.registrationData.motherDesignation !== 'undefined' ? this.registrationData.motherDesignation : ''
          this.studentData.motherQualification =
            !_.isEmpty(this.registrationData.motherQualification) && this.registrationData.motherQualification !== 'undefined' ? this.registrationData.motherQualification : ''
          this.studentData.motherOrganisation =
            !_.isEmpty(this.registrationData.motherOrganisation) && this.registrationData.motherOrganisation !== 'undefined' ? this.registrationData.motherOrganisation : ''
          this.studentData.motherOfficePhoneNo =
            !_.isEmpty(this.registrationData.motherOfficePhoneNo) && this.registrationData.motherOfficePhoneNo !== 'undefined' ? this.registrationData.motherOfficePhoneNo : ''
          this.studentData.motherOfficeAddress =
            !_.isEmpty(this.registrationData.motherOfficeAddress) && this.registrationData.motherOfficeAddress !== 'undefined' ? this.registrationData.motherOfficeAddress : ''
          this.registrationData.franchiseeID = this.parentdata.studentEnrollment.franchiseeID
          this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations = this.isDate(this.registrationData.dateForSeriousAccidentsOrIllnessOrOperations)
          this.registrationData.chikenpoxVaricellaVaccineDate = this.isDate(this.registrationData.chikenpoxVaricellaVaccineDate)
          this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate = this.isDate(this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate)
          this.registrationData.hepatitisAHepAVaccineDate = this.isDate(this.registrationData.hepatitisAHepAVaccineDate)
          this.registrationData.hepatitisBHepBVaccineDate = this.isDate(this.registrationData.hepatitisBHepBVaccineDate)
          this.registrationData.tetanusDTapDate = this.isDate(this.registrationData.tetanusDTapDate)
          this.registrationData.diptheriaDTapVaccineDate = this.isDate(this.registrationData.diptheriaDTapVaccineDate)
          this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions = this.isDate(this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions)
          this.studentData.dateOfBirth = this.isDate(this.parentdata.studentEnrollment.dateOfBirth)
          this.registrationData.enquiryID = this.enquiryID
          this.registrationData.enquiryCode = this.parentdata.studentEnrollment.enquiry.enquiryCode
          this.registrationData.placeOfBirth = !_.isEmpty(this.registrationData.placeOfBirth) && this.registrationData.placeOfBirth !== 'undefined' ? this.registrationData.placeOfBirth : ''
          this.registrationData.getAcademicYear = this.parentdata.franchiseeAcademicYear.academicYear
          this.registrationData.getClassName = this.parentdata.studentClass.name
          this.registrationData.franchiseeName = !_.isEmpty(this.parentdata.franchisee) ? this.parentdata.franchisee.companyName : ''
          this.registrationData.siblingName =
            !_.isEmpty(this.registrationData.siblingName) && this.registrationData.siblingName !== 'undefined' && this.registrationData.siblingName !== null ? this.registrationData.siblingName : ''
          this.registrationData.siblingAge = !_.isEmpty(this.registrationData.siblingAge) && this.registrationData.siblingAge !== 'undefined' ? this.registrationData.siblingAge : ''
          this.registrationData.siblingClass = !_.isEmpty(this.registrationData.siblingClass) && this.registrationData.siblingClass !== 'undefined' ? this.registrationData.siblingClass : ''
          this.registrationData.siblingSchool = !_.isEmpty(this.registrationData.siblingSchool) && this.registrationData.siblingSchool !== 'undefined' ? this.registrationData.siblingSchool : ''
          this.registrationData.referralsChildName =
            !_.isEmpty(this.registrationData.referralsChildName) && this.registrationData.referralsChildName !== 'undefined' ? this.registrationData.referralsChildName : ''
          this.registrationData.referralsChildAge =
            !_.isEmpty(this.registrationData.referralsChildAge) && this.registrationData.referralsChildAge !== 'undefined' ? this.registrationData.referralsChildAge : ''
          this.registrationData.referralsFatherMotherName =
            !_.isEmpty(this.registrationData.referralsFatherMotherName) && this.registrationData.referralsFatherMotherName !== 'undefined' ? this.registrationData.referralsFatherMotherName : ''
          this.registrationData.referralsFatherMotherMobileNo =
            !_.isEmpty(this.registrationData.referralsFatherMotherMobileNo) && this.registrationData.referralsFatherMotherMobileNo !== 'undefined'
              ? this.registrationData.referralsFatherMotherMobileNo
              : ''
          this.registrationData.referralsRelation =
            !_.isEmpty(this.registrationData.referralsRelation) && this.registrationData.referralsRelation !== 'undefined' ? this.registrationData.referralsRelation : ''
          this.registrationData.childsReactionForNewSituation =
            !_.isEmpty(this.registrationData.childsReactionForNewSituation) && this.registrationData.childsReactionForNewSituation !== 'undefined'
              ? this.registrationData.childsReactionForNewSituation
              : ''
          this.registrationData.siblingOtherSchool =
            !_.isEmpty(this.registrationData.siblingOtherSchool) && this.registrationData.siblingOtherSchool !== 'undefined' ? this.registrationData.siblingOtherSchool : ''
          this.registrationData.exposureToEnglishLanguage = !_.isEmpty(this.registrationData.exposureToEnglishLanguage) ? this.registrationData.exposureToEnglishLanguage : ''
          this.registrationData.motherTongue = !_.isEmpty(this.registrationData.motherTongue) ? this.registrationData.motherTongue : ''
          this.registrationData.identificationMarks = !_.isEmpty(this.registrationData.identificationMarks) ? this.registrationData.identificationMarks : ''
          this.typeForm = 'edit_registration'
          this.isLoaded = 'true'
          await this.getEditedInformation()
          if (this.selectedRequestButtonIndex && Object.keys(this.editRequestList).length > 0) {
            let KeyName = Object.keys(this.editRequestList)
            this.showEditRequestForm(KeyName[this.selectedRequestButtonIndex - 1], this.selectedRequestButtonIndex)
            this.selectedButton = this.selectedRequestButtonIndex
          } else {
            this.gotToMainForm()
          }
        } else {
          this.errMsg('No Registration Details Found..')
        }
        const stateresponse = await http.get(`${constants.API_URL}/api/states`)
        this.states = stateresponse.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    truncateFileName (fileName) {
      const maxLength = 10
      const endLength = 3
      const extension = fileName.split('.').pop()
      const nameWithoutExtension = fileName.substring(0, fileName.length - extension.length - 1)

      if (nameWithoutExtension.length <= maxLength + endLength) {
        return fileName
      }

      const truncatedName = nameWithoutExtension.substring(0, maxLength) + '...' + nameWithoutExtension.substring(nameWithoutExtension.length - endLength)
      return `${truncatedName}.${extension}`
    },
    getEditedInformation: async function () {
      try {
        this.editRequestList = []
        if (!this.enquiryID) {
          this.errMsg('Enquiry Id Required.')
          return false
        }
        let res = await http.get(`${constants.API_URL}/api/student/get-edited-information?enquiryID=${this.enquiryID}`)
        if (res.status === 200) {
          let editRequestData = res.data[0]
          if (editRequestData.personalData && editRequestData.personalData.length > 0) {
            editRequestData.personalData.forEach(item => {
              item.infoType = 'personal'
              item.createdAt = moment(item.createdAt).format('MMMM DD, YYYY hh:mm a')
              item.updatedAt = moment(item.updatedAt).format('MMMM DD, YYYY hh:mm a')
              this.editRequestList.push(item)
            })
          }
          if (editRequestData.healthData && editRequestData.healthData.length > 0) {
            editRequestData.healthData.forEach(item => {
              item.infoType = 'health'
              item.createdAt = moment(item.createdAt).format('MMMM DD, YYYY hh:mm a')
              item.updatedAt = moment(item.updatedAt).format('MMMM DD, YYYY hh:mm a')
              this.editRequestList.push(item)
            })
          }
          // fetch image list for edit information.
          if (this.editRequestList.length > 0) {
            this.registrationData.prescribedMedication = this.editRequestList[0].IEenquiryRegistrationHealthCertiMaps
            if (this.registrationData.prescribedMedication) {
              this.registrationData.prescribedMedication.forEach((docID) => {
                // fetch filename from healthCertificateUrl and add it to name key.
                let name = docID.healthCertificateUrl.substring(docID.healthCertificateUrl.lastIndexOf('/') + 1)

                // Truncate the name if it is too long
                docID.name = this.truncateFileName(name)
              })
            }
          }

          this.editRequestList = _.groupBy(this.editRequestList, 'infoType')
          this.editRequestKeyName = Object.keys(this.editRequestList)
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`ERROR in getEditedInformation : ${errorMessage}`)
      }
    },
    isDate: function (date) {
      if (!date) {
        return ''
      } else return moment(date).format('YYYY-MM-DD')
    },
    openModal: async function () {
      this.enableModal = true
    },
    saveRegistration: async function () {
      try {
        if (this.studentData.pointOfContact === 'MOTHER') {
          if (_.isEmpty(this.studentData.motherName) || _.isEmpty(this.studentData.motherEmailID) || _.isEmpty(this.studentData.motherMobile)) {
            this.lock = false
            this.hasClicked = false
            this.errMsg('Please Fill Mother Details as you have selected Mother as Point of contact')
            return false
          }
        }
        if (this.studentData.motherName) {
          if (_.isEmpty(this.studentData.motherEmailID) || _.isEmpty(this.studentData.motherMobile)) {
            this.errMsg('mother name can not be empty.')
            return false
          }
        } else if (this.studentData.motherMobile) {
          if (_.isEmpty(this.studentData.motherName) || this.studentData.motherEmailID === null) {
            this.errMsg('Please fill all mandetory mother details.')
            return false
          }
        }
        this.hasClicked = true
        this.loader = true
        this.parentdata.enquiry = ''
        let inputData = {
          motherTongue: this.registrationData.motherTongue,
          exposureToEnglishLanguage: this.registrationData.exposureToEnglishLanguage,
          identificationMarks: this.registrationData.identificationMarks,
          studentName: this.studentData.studentName,
          fatherName: this.studentData.fatherName,
          fatherMobile: this.studentData.fatherMobile,
          fatherEmail: this.studentData.fatherEmailID,
          fatherOccupation: this.studentData.fatherOccupation,
          motherName: this.studentData.motherName,
          motherEmailID: this.studentData.motherEmailID,
          motherMobile: this.studentData.motherMobile,
          motherOccupation: this.studentData.motherOccupation,
          address: this.studentData.address,
          pincode: this.studentData.pincode,
          countryName: this.studentData.countryName,
          state: this.studentData.state,
          city: this.studentData.city,
          locality: this.studentData.locality,
          dateOfBirth: this.studentData.dateOfBirth,
          gender: this.studentData.gender,
          pointOfContact: this.studentData.pointOfContact,
          relationWithApplicant: this.studentData.relationWithApplicant,
          guardianName: this.studentData.guardianName,
          guardianMobile: this.studentData.guardianMobile,
          guardianEmailID: this.studentData.guardianEmailID,
          fatherDesignation: this.studentData.fatherDesignation,
          fatherQualification: this.studentData.fatherQualification,
          fatherOrganisation: this.studentData.fatherOrganisation,
          fatherOfficePhoneNo: this.studentData.fatherOfficePhoneNo,
          fatherOfficeAddress: this.studentData.fatherOfficeAddress,
          motherQualification: this.studentData.motherQualification,
          motherOrganisation: this.studentData.motherOrganisation,
          motherOfficePhoneNo: this.studentData.motherOfficePhoneNo,
          motherOfficeAddress: this.studentData.motherOfficeAddress,
          motherDesignation: this.studentData.motherDesignation,
          emergencyContactDetails: this.studentData.emergencyContactDetails,
          placeOfBirth: this.registrationData.placeOfBirth,
          siblingName: this.registrationData.siblingName,
          siblingAge: this.registrationData.siblingAge,
          siblingClass: this.registrationData.siblingClass,
          siblingSchool: this.registrationData.siblingSchool,
          siblingOtherSchool: this.registrationData.siblingOtherSchool,
          referralsChildName: this.registrationData.referralsChildName,
          referralsChildAge: this.registrationData.referralsChildAge,
          referralsFatherMotherName: this.registrationData.referralsFatherMotherName,
          referralsFatherMotherMobileNo: this.registrationData.referralsFatherMotherMobileNo,
          referralsRelation: this.registrationData.referralsRelation,
          bloodGroup: this.registrationData.bloodGroup,
          anySeriousAccidentsOrIllnessOrOperarions: this.registrationData.anySeriousAccidentsOrIllnessOrOperarions,
          dateForSeriousAccidentsOrIllnessOrOperarions: this.registrationData.dateForSeriousAccidentsOrIllnessOrOperarions,
          allergiesOrAsthmaOrBreathlessness: this.registrationData.allergiesOrAsthmaOrBreathlessness,
          anyOtherAliment: this.registrationData.anyOtherAliment,
          specialCare: this.registrationData.specialCare,
          foodAllergies: this.registrationData.foodAllergies,
          drugAllergies: this.registrationData.drugAllergies,
          anyPhysicalChallengeOrLearningDifficulties: this.registrationData.anyPhysicalChallengeOrLearningDifficulties,
          // prescribedMedication: this.registrationData.prescribedMedication,
          techniqueToDisciplineYourChild: this.registrationData.techniqueToDisciplineYourChild,
          childsUsualReactionToBeingDisciplined: this.registrationData.childsUsualReactionToBeingDisciplined,
          childsReactionForNewSituation: this.registrationData.childsReactionForNewSituation,
          isNewPeopleEasilyAcceptable: this.registrationData.isNewPeopleEasilyAcceptable,
          familyDoctorOrPhysicianName: this.registrationData.familyDoctorOrPhysicianName,
          familyDoctorOrPhysicianQualification: this.registrationData.familyDoctorOrPhysicianQualification,
          practicingClinicDetails: this.registrationData.practicingClinicDetails,
          practicingClinicOfficeTelephone: this.registrationData.practicingClinicOfficeTelephone,
          practicingClinicMobileNo: this.registrationData.practicingClinicMobileNo,
          practicingClinicEmailID: this.registrationData.practicingClinicEmailID,
          chikenpoxVaricellaVaccineDate: this.registrationData.chikenpoxVaricellaVaccineDate,
          diptheriaDTapVaccineDate: this.registrationData.diptheriaDTapVaccineDate,
          haemophilusInfluenzaTypeBHiBVaccineDate: this.registrationData.haemophilusInfluenzaTypeBHiBVaccineDate,
          hepatitisAHepAVaccineDate: this.registrationData.hepatitisAHepAVaccineDate,
          hepatitisBHepBVaccineDate: this.registrationData.hepatitisBHepBVaccineDate,
          tetanusDTapDate: this.registrationData.tetanusDTapDate,
          studentPhotoUrl: !_.isEmpty(this.registrationData.studentPhotoUrl) ? this.registrationData.studentPhotoUrl : '',
          fatherPhotoUrl: !_.isEmpty(this.registrationData.fatherPhotoUrl) ? this.registrationData.fatherPhotoUrl : '',
          motherPhotoUrl: !_.isEmpty(this.registrationData.motherPhotoUrl) ? this.registrationData.motherPhotoUrl : '',
          birthCertificateUrl: !_.isEmpty(this.registrationData.birthCertificateUrl) ? this.registrationData.birthCertificateUrl : '',
          transferCertificateUrl: !_.isEmpty(this.registrationData.transferCertificateUrl) ? this.registrationData.transferCertificateUrl : '',
          immunisationCertificateUrl: !_.isEmpty(this.registrationData.immunisationCertificateUrl) ? this.registrationData.immunisationCertificateUrl : '',
          studentAadharCardUrl: !_.isEmpty(this.registrationData.studentAadharCardUrl) ? this.registrationData.studentAadharCardUrl : '',
          fatherAadharCardUrl: !_.isEmpty(this.registrationData.fatherAadharCardUrl) ? this.registrationData.fatherAadharCardUrl : '',
          motherAadharCardUrl: !_.isEmpty(this.registrationData.motherAadharCardUrl) ? this.registrationData.motherAadharCardUrl : '',
          healthCertificateUrl: !_.isEmpty(this.registrationData.healthCertificateUrl) ? this.registrationData.healthCertificateUrl : '',
          senCertificateUrl: !_.isEmpty(this.registrationData.senCertificateUrl) ? this.registrationData.senCertificateUrl : '',
          studentPhoto: this.registrationData.studentPhoto,
          fatherPhoto: this.registrationData.fatherPhoto,
          motherPhoto: this.registrationData.motherPhoto,
          birthCertificate: this.registrationData.birthCertificate,
          transferCertificate: this.registrationData.transferCertificate,
          immunisationCertificate: this.registrationData.immunisationCertificate,
          studentAadharCard: this.registrationData.studentAadharCard,
          fatherAadharCard: this.registrationData.fatherAadharCard,
          motherAadharCard: this.registrationData.motherAadharCard,
          healthCertificate: this.registrationData.healthCertificate,
          registrationCode: this.registrationData.registrationCode,
          enquiryCode: this.registrationData.enquiryCode,
          iAgreeCheckbox: this.registrationData.iAgreeCheckbox,
          senCertificate: this.registrationData.senCertificate,
        }
        const formData = new FormData()
        for (var key in inputData) {
          if (typeof inputData[key] === 'undefined' || inputData[key] === null) {
            inputData[key] = ''
          }
          formData.append(key, inputData[key])
        }
        if (this.registrationData.dropFile) {
          for (let i = 0; i < this.registrationData.dropFile.length; i++) {
            formData.append('prescribedMedicationFile', this.registrationData.dropFile[i])
          }
        }
        await http.put(`${constants.API_URL}/api/edit-registrations/v1/${this.admissionID}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        this.dialog = true
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(`Error in saveRegistration function :${errorMessage}`)
      }
    },
    showEditRequestForm: function (keyName, index) {
      console.log(keyName, index)
      this.requestTabData = {}
      this.isOldFormViewRequested = false
      this.isPersonalDataChanges = false
      this.isHealthDataChanges = false
      this.selectedRequestButtonIndex = index
      this.editRequestFormType = 'edit_registration'
      this.personalDetailsData = []
      this.healthDetailsData = []
      this.groupHealthDetailsData = {}
      if (keyName === 'personal') {
        this.selectRequestButton = keyName
        this.isPersonalDataChanges = true
        this.personalDetailsData = this.editRequestList[keyName]
      } else if (keyName === 'health') {
        this.selectRequestButton = keyName
        this.isHealthDataChanges = true
        this.healthDetailsData = this.editRequestList[keyName]
        this.groupHealthDetailsData = _.groupBy(this.healthDetailsData, 'isChange')
        console.log(this.groupHealthDetailsData)
      } else {
        this.selectRequestButton = null
        this.isOldFormViewRequested = true
        this.isPersonalDataChanges = false
        this.isHealthDataChanges = false
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}

</script>
<style>
.request-btn-container{
  gap:10px;
}
</style>
